// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__QcWaX","imgPreloader":"AboutMe_imgPreloader__eqlnW","imgError":"AboutMe_imgError__+l-97","title":"AboutMe_title__RH4kr"};